module.exports = __webpack_public_path__ + "img/Staff_Productivity_Dashboard.1b10b6cd.jpeg";